import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, mapToCanActivate } from '@angular/router';

import { AuthGuard } from '../../../services/authguard-service';
import { ImportedCsvComponent } from './imported-csv.component';

const appRoutes: Routes = [
  {
    path: ':discoverytype/:reportid',
    component: ImportedCsvComponent,
    canActivate: mapToCanActivate([AuthGuard])
  },
  {
    path: ':discoverytype/:reportid/:param1/:param2/:param3',
    component: ImportedCsvComponent,
    canActivate: mapToCanActivate([AuthGuard])
  }
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
